import { render, staticRenderFns } from "./ttsEditor.vue?vue&type=template&id=5e0c6290"
import script from "./ttsEditor.vue?vue&type=script&lang=js"
export * from "./ttsEditor.vue?vue&type=script&lang=js"
import style0 from "./ttsEditor.vue?vue&type=style&index=0&id=5e0c6290&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports